import { addRoutes as addNewRoutes } from './app-router';

class RoutingUtils {
  addRoutes = (appRoutingTable: any) => addNewRoutes(appRoutingTable);
}

export default new RoutingUtils();
